import dayjs from 'dayjs';

import { type TDataSourceResponses } from '@/types/dataSource';

export const findFinancedOfferDate = (responses: TDataSourceResponses[]) => {
  const filteredArray = [...responses].filter(
    (response) => response.status === 'financed'
  );
  if (filteredArray.length > 0 && filteredArray[0].funded_date) {
    return dayjs(filteredArray[0].funded_date!).format('DD.MM.YYYY');
  } else {
    return '—';
  }
};
